import _remove from 'lodash/remove';
import addStudentTemplate from './../../settings/add-student/add-student.html';
import template from './add-talk.html';

class AddTalkComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    StudentService,
    TalkService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.StudentService = StudentService;
    this.TalkService = TalkService;

    this.talk = {};
    this.selectedStudents = [];
    this.selectedStudentsIDs = [];
  }

  $onChanges(changes) {
    if (changes.students) {
      this.students = Object.assign([], this.students);
    }
  }

  addStudent(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddStudentController',
      template: addStudentTemplate,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(result => {
        _remove(this.selectedStudents, student => student.id === result.id);
        this.selectedStudents.unshift(result);
        this.selectedStudentsIDs.push(Number(result.id));
      }, () => {});
  }

  removeStudent(studentToRemove) {
    _remove(this.selectedStudentsIDs, id => id === Number(studentToRemove.id));
    _remove(this.selectedStudents, student => student.id === studentToRemove.id);
    this.students.push(studentToRemove);
  }

  add(form) {
    if (form.$invalid) {
      return false;
    }

    this.talk.date = this.moment(this.date).format('YYYY-MM-DD');
    this.talk.students = this.selectedStudentsIDs;
    this.talk.studentObjects = this.selectedStudents;

    this.TalkService.add(
      {
        data: this.talk,
        addToLocal: true
      }
    ).then(() => {
      this.$state.go('modules.talks');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Dodano rozmowę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const AddTalk = {
  bindings: {
    students: '<'
  },
  template,
  controller: AddTalkComponent
};
